'use strict'

const TAB_NAME_HOME = "Home";
const TAB_NAME_WATCHLIST = "Watchlist";
const TAB_NAME_USER_SEARCH_HISTORY = "History";
const TAB_NAME_METRICS = "Metrics";
const TAB_NAME_ADMIN = "Admin";
const TAB_TITLE_INSTANCE = "INSTANCE ";
const TAB_TITLE_FILE_ACCESS = "FILE ACCESS "
const TAB_TITLE_SITE_VIEW = "SITE VIEW "
const TAB_NAME_RSU = "RSU";
const TAB_NAME_RSU_DASHBOARD = "rsuDashboard"; //added different name as per casbin rule
const TAB_NAME_METRICS_DASHBOARD = "metricsDashboard";//added different name as per casbin rule
const TAB_NAME_METERING = "METERING";
const TAB_NAME_INSTRUMENT_DASHBOARD = "ONBOARDINSTRUMENT";
const TAB_NAME_CREATE_TRIGGERS = "createtriggers"
const TAB_NAME_TRIGGERS = "Triggers"
const TAB_NAME_RB_REPORTS = "RB REPORT"
const TAB_NAME_CAL_REPORTS = "CAL REPORT"
const TAB_NAME_PIP_REPORTS = "PIPETTOR REPORT"
const TAB_NAME_CARRYOVER_REPORTS = "CARRYOVER REPORT"
const TAB_NAME_LOWVOLUME_REPORT = "LOW VOLUME REPORT"
const TAB_NAME_SYSTEM_CHECK_REPORT = "SYSTEM CHECK REPORT"
const TAB_NAME_RM_REPORTS = "RM PLOT"
const TAB_NAME_RM_WAVELENGTHS = "RM PHOTOMETRY WAVELENGTHS PLOT"
const TAB_NAME_RA_MANAGEMENT = "RA_MANAGEMENT"
const TAB_NAME_CONFIGURATIONS_TRANSFER = "configurationTransfer"
const TAB_NAME_RULES = "TRIGGER DETAILS"

export {
    TAB_NAME_HOME,
    TAB_NAME_WATCHLIST,
    TAB_NAME_METRICS,
    TAB_TITLE_INSTANCE,
    TAB_TITLE_FILE_ACCESS,
    TAB_NAME_RSU,
    TAB_NAME_ADMIN,
    TAB_NAME_RSU_DASHBOARD,
    TAB_NAME_METRICS_DASHBOARD,
    TAB_NAME_METERING,
    TAB_NAME_INSTRUMENT_DASHBOARD,
    TAB_NAME_USER_SEARCH_HISTORY,
    TAB_TITLE_SITE_VIEW,
    TAB_NAME_CREATE_TRIGGERS,
    TAB_NAME_TRIGGERS,
    TAB_NAME_RB_REPORTS,
    TAB_NAME_CAL_REPORTS,
    TAB_NAME_PIP_REPORTS,
    TAB_NAME_CARRYOVER_REPORTS,
    TAB_NAME_LOWVOLUME_REPORT,
    TAB_NAME_SYSTEM_CHECK_REPORT,
    TAB_NAME_RM_REPORTS,
    TAB_NAME_RM_WAVELENGTHS,
    TAB_NAME_RA_MANAGEMENT,
    TAB_NAME_CONFIGURATIONS_TRANSFER,
    TAB_NAME_RULES
}
